import { render } from "./SelectionChip.vue?vue&type=template&id=ddf6d9c2&scoped=true"
import script from "./SelectionChip.vue?vue&type=script&lang=js"
export * from "./SelectionChip.vue?vue&type=script&lang=js"

import "./SelectionChip.vue?vue&type=style&index=0&id=ddf6d9c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf6d9c2"]])

export default __exports__